import React from 'react';
import tw from 'twin.macro';
// import { css } from 'styled-components/macro';
import { motion } from 'framer-motion';
import AnimationRevealPage from "../helpers/AnimationRevealPage.js";
import Headers from "src/components/headers/light.js";

const Container = tw.div`p-8 max-w-6xl mx-auto text-gray-800 bg-white rounded-2xl shadow-lg mt-10 mb-10`;
const Section = tw.div`mt-10`;
const Title = tw.h1`text-5xl font-extrabold text-center text-indigo-700 mb-6`;
const Subtitle = tw.h2`text-3xl font-semibold text-indigo-600 mb-2`;
const Paragraph = tw.p`mb-4 leading-relaxed text-xl text-secondary-900`;
const List = tw.ul`list-disc ml-6 mt-2 text-secondary-900`;

const fadeIn = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5 } }
};

const PrivacyPolicy = () => {
  return (
    
    <motion.div initial="hidden" animate="visible" variants={fadeIn}>
      <Container>
        <Headers></Headers>
        <AnimationRevealPage>
        <Title>Privacy Policy</Title>

        <Paragraph>
          At Blake Technologies, your privacy is of utmost importance to us. This Privacy Policy outlines how we collect, use, and safeguard your personal data while you interact with our API Dashboard App.
        </Paragraph>

        <Section>
          <Subtitle>1. Information We Collect</Subtitle>
          <Paragraph>
            We collect the following types of information:
          </Paragraph>
          <List>
            <li>Personal identifiers (e.g., name, email address)</li>
            <li>Authentication and account details</li>
            <li>API usage statistics and logs</li>
            <li>Billing and payment history</li>
            <li>Support queries and feedback</li>
            <li><strong>Aggregate Information</strong> Aggregate Information is information about your activities on or in connection with the Services that typically cannot be used to identify, locate, or contact you or your Visitors. For example, Aggregate Information includes information regarding the frequency of use of the Services, quantity and type of data entered when using the Services, components of the Services most frequently accessed, and browser types used to access the Services.</li>
          </List>
        </Section>

        <Section>
          <Subtitle>2. How We Use Your Information</Subtitle>
          <Paragraph>We use your data to:</Paragraph>
          <List>
            <li>Provide and improve our services</li>
            <li>Track API requests and usage analytics</li>
            <li>Facilitate secure payments and subscriptions</li>
            <li>Communicate important updates and alerts</li>
            <li>Respond to support tickets and user inquiries</li>
          </List>
        </Section>

        <Section>
          <Subtitle>3. Sharing Your Information</Subtitle>
          <Paragraph>
            We only share your information with trusted third-party services such as Firebase, Paystack, and RevenueCat, necessary to operate and maintain our platform. We never sell or rent your personal data to external parties. Your data may be stored or processed in regions outside of your country of residence. We ensure secure handling and encryption of all information, regardless of location.
          </Paragraph>
          <Paragraph>
            Blake Technologies may share Aggregate Information with its affiliates and certain third parties, such as investors, potential investors, and third party service providers we use to provide the Services. Aggregate Information is anonymized and does not have the capacity to be used to identify an individual. In other words, Blake Technologies may share this information but no Personal Data will be disclosed to third parties
          </Paragraph>
        </Section>

        <Section>
          <Subtitle>4. Data Security</Subtitle>
          <Paragraph>
            We take data security seriously. Your data is protected with end-to-end encryption, secure database access, and role-based permission management. We also conduct regular system audits to maintain security compliance.
          </Paragraph>
        </Section>

        <Section>
          <Subtitle>5. Cookies & Tracking</Subtitle>
          <Paragraph>
            Our app may use cookies or similar technologies to enhance user experience, gather analytics, and store user preferences. You may opt out of these features through your browser settings.
          </Paragraph>
        </Section>

        <Section>
          <Subtitle>6. Your Rights</Subtitle>
          <Paragraph>
            You have the right to:
          </Paragraph>
          <List>
            <li>Access your personal data</li>
            <li>Request updates or corrections to your information</li>
            <li>Delete your account and associated data</li>
            <li>Withdraw consent to data processing</li>
          </List>
        </Section>

        <Section>
          <Subtitle>7. Children’s Privacy</Subtitle>
          <Paragraph>
            Our services are not intended for use by children under the age of 13. We do not knowingly collect personal data from minors.
          </Paragraph>
        </Section>

        <Section>
            <Subtitle>8. External Links</Subtitle>
            <Paragraph>
                The Services may contain links to third party websites operated by other people or companies. We do not guarantee that we have endorsed or reviewed any links to third-party websites. Blake Technologies is not responsible for those websites, and links to such websites are solely for your convenience. We cannot control nor are we responsible for the privacy practices or consent of these third-party websites. We suggest contacting these websites directly for information on their privacy policies.
            </Paragraph>
        </Section>

        <Section>
          <Subtitle>9. Updates to This Policy</Subtitle>
          <Paragraph>
            We reserve the right to update this policy as needed. Any changes will be communicated via app notifications or on our official website.
          </Paragraph>
        </Section>

        <Section>
          <Subtitle>10. Contact Us</Subtitle>
          <Paragraph>
            If you have any questions or concerns regarding your data or this policy, please contact us:
            <br />
            <strong>Email:</strong> info@blaketechhq.com
          </Paragraph>
        </Section>
        </AnimationRevealPage>
      </Container>
    </motion.div>
  );
};

export default PrivacyPolicy;
